// @flow

import React from 'react';

const Visa = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="20"
    viewBox="0 0 29 20">
    <g fill="none" fillRule="evenodd">
      <rect width="29" height="20" fill="#224DBA" rx="2.707" />
      <path
        fill="#FFF"
        d="M9.91 13.14h-1.7l-1.274-4.8c-.06-.222-.19-.417-.378-.509A5.581 5.581 0 0 0 5 7.323v-.185h2.738a.71.71 0 0 1 .708.6l.661 3.463 1.699-4.063h1.652L9.909 13.14zm3.493 0h-1.605l1.321-6.002h1.605l-1.321 6.001zM16.8 8.8c.047-.322.33-.507.66-.507a3.024 3.024 0 0 1 1.558.277l.284-1.292A4.109 4.109 0 0 0 17.84 7c-1.558 0-2.692.831-2.692 1.985 0 .877.803 1.338 1.37 1.616.613.277.85.461.802.738 0 .415-.472.6-.944.6a4.09 4.09 0 0 1-1.652-.37l-.283 1.293c.566.23 1.18.324 1.746.324 1.747.045 2.832-.785 2.832-2.032 0-1.57-2.218-1.661-2.218-2.353zm7.835 4.34l-1.274-6.002h-1.369a.71.71 0 0 0-.661.462l-2.36 5.54h1.652l.33-.878h2.03l.19.877h1.462zM22.23 8.753l.472 2.262h-1.322l.85-2.262z"
      />
    </g>
  </svg>
);

export default Visa;



// WEBPACK FOOTER //
// ./src/assets/icons/card-visa-svg.js